<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="select-portal-company-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
          </button>

          <h4 class="modal-title">
            Select Company
          </h4>
        </div>

        <div v-if="!loading" class="modal-body">
          <ul class="nav nav-tabs" role="tablist">
            <li role="presentation" class="active">
              <a href="#search" aria-controls="search" role="tab" data-toggle="tab">Search</a>
            </li>

            <li role="presentation">
              <a href="#create" aria-controls="create" role="tab" data-toggle="tab">Create</a>
            </li>
          </ul>

          <div class="tab-content" style="padding-top: 15px;">
            <div role="tabpanel" class="tab-pane active" id="search">
              <form @submit.prevent="search">
                <div class="row">
                  <div class="col-xs-20">
                    <div class="form-group">
                      <input class="form-control input-sm" placeholder="Search..." type="text" v-model="searchValue">
                    </div>
                  </div>

                  <div class="col-xs-4">
                    <button type="submit" class="btn btn-block btn-sm btn-black">
                      <i class="fa fa-search"/> Search
                    </button>
                  </div>
                </div>
              </form>

              <table class="table table-condensed table-striped">
                <thead>
                <tr>
                  <th class="col-xs-7">
                    Company Name
                  </th>

                  <th class="col-xs-7">
                    Company CVR
                  </th>

                  <th class="col-xs-7">
                    Portal Alias
                  </th>

                  <th class="col-xs-3"></th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="company in companies">
                  <td>
                    {{ company.name }}
                  </td>

                  <td>
                    {{ company.cvr }}
                  </td>

                  <td>
                    {{ company.portal_company_name }}

                    <span v-if="!company.portal_company_id" class="label label-info">
                      Not on portal
                    </span>
                  </td>

                  <td class="text-right">
                    <button
                        v-if="company.portal_company_id"
                        type="button"
                        class="btn btn-xs btn-black"
                        @click="selectPortalCompany(company.portal_company_id, company.portal_company_name, company.name)"
                    >
                      <i class="fa fa-check"/> Select
                    </button>

                    <button
                        v-else
                        type="button"
                        class="btn btn-xs btn-black"
                        @click="createPortalCompany(company.id, company.name)"
                    >
                      <i class="fa fa-check"/> Select
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div role="tabpanel" class="tab-pane" id="create">
              <form @submit.prevent="createCompany">

                <FormGroup name="cvr" label="CVR" help-text="The company's CVR number." :error="(errors.cvr || [])[0]">
                  <div class="row">
                    <div class="col-xs-16">
                      <input name="cvr" placeholder="CVR" class="form-control" type="text" v-model="data.cvr">
                    </div>

                    <div class="col-xs-8">
                      <button type="button" class="btn btn-white btn-block" @click="lookupCVRNumber">
                        <i class="fa fa-search"/> Lookup
                      </button>
                    </div>
                  </div>
                </FormGroup>

                <TextFormGroup
                    v-model="data.name"
                    name="name"
                    label="Name"
                    help-text="The name of the company."
                    :error="(errors.name || [])[0]"
                />

                <div class="row">
                  <div class="col-sm-8">
                    <TextFormGroup
                        v-model="data.address.street_name"
                        name="address.street_name"
                        label="Street Name"
                        :error="(errors['address.street_name'] || [])[0]"
                    />
                  </div>

                  <div class="col-sm-4">
                    <TextFormGroup
                        v-model="data.address.street_number"
                        name="address.street_number"
                        label="Number"
                        :error="(errors['address.street_number'] || [])[0]"
                    />
                  </div>

                  <div class="col-sm-4">
                    <TextFormGroup
                        v-model="data.address.street_letter"
                        name="address.street_letter"
                        label="Letter"
                        :error="(errors['address.street_letter'] || [])[0]"
                    />
                  </div>

                  <div class="col-sm-4">
                    <TextFormGroup
                        v-model="data.address.street_floor"
                        name="address.street_floor"
                        label="Floor"
                        :error="(errors['address.street_floor'] || [])[0]"
                    />
                  </div>

                  <div class="col-sm-4">
                    <TextFormGroup
                        v-model="data.address.street_location"
                        name="address.street_location"
                        label="Location"
                        :error="(errors['address.street_location'] || [])[0]"
                    />
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-8">
                    <TextFormGroup
                        v-model="data.address.zip_code"
                        name="address.zip_code"
                        label="Zip Code"
                        :error="(errors['address.zip_code'] || [])[0]"
                    />
                  </div>

                  <div class="col-sm-16">
                    <TextFormGroup
                        v-model="data.address.city"
                        name="address.city"
                        label="City"
                        :error="(errors['address.city'] || [])[0]"
                    />
                  </div>
                </div>

                    <SelectFormGroup
                        v-model="data.address.country"
                        name="address.country"
                        label="Country"
                        :error="(errors['address.country'] || [])[0]"
                        :options="countryOptions"
                    />

                <button type="submit" class="btn btn-black btn-block">
                  <i class="fa fa-save"></i> Save
                </button>
              </form>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import FormGroup from '@/vendor/forms/FormGroups/Block/FormGroup'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Block/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {FormGroup, SelectFormGroup, SubmitFormGroup, TextFormGroup},

  props: {
    portal: {
      required: true,
    }
  },

  data() {
    return {
      data: {
        address: {country: 'DK'},

        tags: []
      },

      countries: null,
      companies: null,

      searchValue: '',

      loading: true,

      errors: {},
    }
  },

  mounted() {
    this.listenForClose()

    this.load()
  },

  computed: {
    countryOptions() {
      return this.countries.map(country => ({
        value: country.id,
        label: country.attributes.name
      }))
    },
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/countries'),
        http.get('/api/v2/companies', {page_size: 10})
      ]).then(responses => {
        this.countries = responses[0].data.data

        this.companies = responses[1].data.data.map(company => this.mapCompany(company))

        this.loading = false
      })
    },

    search() {
      http.get('/api/v2/companies', {'filter[search]': this.searchValue, page_size: 10}).then(response => {
        this.companies = response.data.data.map(company => this.mapCompany(company))
      })
    },

    mapCompany(company) {
      return {
        id: company.id,
        name: company.attributes.name,
        cvr: company.attributes.cvr,
        portal_company_id: company.attributes.portal_companies.find(portalCompany => portalCompany.portal_id === this.portal.id)?.id,
        portal_company_name: company.attributes.portal_companies.find(portalCompany => portalCompany.portal_id === this.portal.id)?.name,
      }
    },

    listenForClose() {
      $('#select-portal-company-modal').on('hidden.bs.modal', this.reset)
    },

    reset() {
      this.data = {address: {country: 'DK'}, tags: []}

      this.searchValue = ''

      this.load()
    },

    lookupCVRNumber() {
      if (!this.data.cvr) {
        return
      }

      http.get('/api/v2/cvr-companies/' + this.data.cvr).then(response => {
        this.data = {
          ...this.data,
          ...response.data.data.attributes,

          address: {
            ...response.data.data.attributes.address,
            country: this.data.address.country,
          },
        }
      })
    },

    createCompany() {
      http.post('/api/v2/companies', this.data).then(response => {
        this.createPortalCompany(response.data.data.id, response.data.data.attributes.name)
      }).catch(error => {
        if (error.response.status === 422) {
          this.errors = error.response.data.errors
        }
      })
    },

    createPortalCompany(companyId, companyName) {
      http.post('/api/v2/portal-companies', {portal_id: this.portal.id, company_id: companyId}).then(response => {
        this.selectPortalCompany(response.data.data.id, null, companyName)
      })
    },

    selectPortalCompany(portalCompanyId, portalCompanyName, companyName) {
      this.$emit('selected', {
        portal_company_id: portalCompanyId,
        portal_company_name: portalCompanyName,
        company_name: companyName,
      })

      $(this.$el).modal('hide')
    }
  }
}
</script>
